// This hook is created to fetch creator details without any auth
import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import {
  CREATORS_COLLECTION_QUERY_KEY,
  CREATOR_PROFILE_QUERY_KEY,
} from '~/queries/keys';

export const useFetchCreatorPublic = (idOrSlug: string) => {
  const qc = useQueryClient();

  return useQuery({
    queryKey: [CREATORS_COLLECTION_QUERY_KEY, { id: idOrSlug }],
    queryFn: () =>
      axios.get(`/api/creators/${idOrSlug}`).then((r) => ({
        ...r.data,
      })),
    onSuccess: (data) => {
      // Populate the query data for creator slug too (used in charts)
      qc.setQueryData([CREATOR_PROFILE_QUERY_KEY, { slug: data.slug }], data);
    },
    retry: 0,
  });
};
